"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Edit2, Bell } from "lucide-react"
import { NotificationsModal } from "@/components/ui/notifications/notifications-modal"

interface ProfileHeaderProps {
  studentName?: string
  onEditProfile?: () => void
}

export function ProfileHeader({ 
  studentName = "Student Profile", 
  onEditProfile 
}: ProfileHeaderProps) {
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)

  // Mock function to handle marking notifications as read
  const handleMarkAsRead = (notificationId: string) => {
    console.log("Marking notification as read:", notificationId)
    // Implement your logic to mark notification as read
  }

  const handleMarkAllAsRead = () => {
    console.log("Marking all notifications as read")
    // Implement your logic to mark all notifications as read
  }

  return (
    <>
      <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div>
          <h1 className="text-4xl font-bold text-slate-900">{studentName}</h1>
          <p className="text-slate-600 mt-1">Manage your profile and view your achievements</p>
        </div>
        <div className="flex items-center gap-3">
          <Button 
            variant="outline" 
            size="icon" 
            className="relative rounded-lg border-slate-300 hover:bg-slate-100 transition-all hover:scale-105"
            aria-label="Notifications"
            onClick={() => setIsNotificationsOpen(true)}
          >
            <Bell className="w-5 h-5 text-slate-700" />
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
          </Button>
          
          {/* Commented out Edit Profile button as per original code */}
          {/* <Button 
            onClick={onEditProfile}
            className="bg-indigo-600 hover:bg-indigo-700 text-white flex items-center gap-2 shadow-sm hover:shadow-md transition-shadow"
          >
            <Edit2 className="w-4 h-4" />
            Edit Profile
          </Button> */}
        </div>
      </header>

      <NotificationsModal
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
        onMarkAsRead={handleMarkAsRead}
        onMarkAllAsRead={handleMarkAllAsRead}
        position="top-right"
      />
    </>
  )
}